module.exports = __webpack_public_path__ + "img/strengthscrm-image4.82cf765a.svg";